import { Group, Table } from "@mantine/core";
import { SystemEmailRegistryEntry } from "../../../services/admin/systemEmails.service";
import { SystemEmailModeControl } from "./SystemEmailModeControl";
import { SystemEmailAttachmentIndicator } from "./SystemEmailAttachmentIndicator";

export function SystemEmailRegistryModeCell({
  entry,
}: {
  entry: SystemEmailRegistryEntry;
}) {
  return (
    <Table.Td>
      <Group gap="xs" wrap="nowrap">
        <SystemEmailModeControl entry={entry} />
        {entry.hasAttachment && <SystemEmailAttachmentIndicator />}
      </Group>
    </Table.Td>
  );
}
